// ThemeToggle — переключатель темы (light/dark/system) через IconButton.
// Циклически переключает mode: light → dark → system → light.
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { useThemeMode, type ThemeMode } from '@/theme';

const order: ThemeMode[] = ['light', 'dark', 'system'];

function nextMode(current: ThemeMode): ThemeMode {
  const idx = order.indexOf(current);
  return order[(idx + 1) % order.length] as ThemeMode;
}

const labelByMode: Record<ThemeMode, string> = {
  light: 'Светлая тема',
  dark: 'Тёмная тема',
  system: 'Системная тема',
};

export function ThemeToggle(): JSX.Element {
  const { mode, setMode } = useThemeMode();
  const icon =
    mode === 'light' ? <LightModeIcon /> : mode === 'dark' ? <DarkModeIcon /> : <SettingsBrightnessIcon />;

  return (
    <Tooltip title={`${labelByMode[mode]} (клик — переключить)`}>
      <IconButton
        color="inherit"
        onClick={() => setMode(nextMode(mode))}
        aria-label="Переключить тему"
        data-testid="theme-toggle"
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}
